import "@dxos/node-std/globals";
import {
  Framer,
  Muxer,
  Teleport,
  TestBuilder,
  TestConnection,
  TestExtension,
  TestExtensionWithStreams,
  TestPeer,
  decodeFrame,
  encodeFrame
} from "./chunk-7OL3IB7N.mjs";

// src/rpc-extension.ts
import { invariant } from "@dxos/invariant";
import { createProtoRpcPeer } from "@dxos/rpc";
var __dxlog_file = "/__w/dxos/dxos/packages/core/mesh/teleport/src/rpc-extension.ts";
var RpcExtension = class {
  _rpcProps;
  // TODO(dmaretskyi): Type optionally.
  _extensionContext;
  _rpc;
  _isClosed = false;
  constructor(_rpcProps) {
    this._rpcProps = _rpcProps;
  }
  get initiator() {
    return this._extensionContext?.initiator;
  }
  get localPeerId() {
    return this._extensionContext?.localPeerId;
  }
  get remotePeerId() {
    return this._extensionContext?.remotePeerId;
  }
  get rpc() {
    invariant(this._rpc, void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 25, S: this, A: ["this._rpc", ""] });
    return this._rpc.rpc;
  }
  async onOpen(context) {
    this._extensionContext = context;
    const handlers = await this.getHandlers();
    if (this._isClosed) {
      return;
    }
    const port = await context.createPort("rpc", {
      contentType: 'application/x-protobuf; messageType="dxos.rpc.Message"'
    });
    this._rpc = createProtoRpcPeer({
      ...this._rpcProps,
      handlers,
      port
    });
    await this._rpc.open();
  }
  async onClose(err) {
    this._isClosed = true;
    await this._rpc?.close();
  }
  async onAbort(err) {
    this._isClosed = true;
    await this._rpc?.abort();
  }
  close() {
    this._extensionContext?.close();
  }
};
export {
  Framer,
  Muxer,
  RpcExtension,
  Teleport,
  TestBuilder,
  TestConnection,
  TestExtension,
  TestExtensionWithStreams,
  TestPeer,
  decodeFrame,
  encodeFrame
};
//# sourceMappingURL=index.mjs.map
